export const isValidCombinedLength = (
    maxLenght: number,
    label: string,
    fields: string[],
) => {
    return fields.every((field) => label.length + field.length <= maxLenght);
};
